import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer, ReferenceLine
} from 'recharts';
import { format } from 'date-fns';
import { sr } from 'date-fns/locale';

function CustomTooltip({ active, payload, label }) {
  if (active && payload && payload.length) {
    return (
      <div style={{
        background: 'white', border: '1px solid #e8ddd8', borderRadius: 10,
        padding: '12px 16px', boxShadow: '0 4px 16px rgba(45,36,32,0.12)', fontSize: 13
      }}>
        <p style={{ fontWeight: 700, marginBottom: 6, color: '#5c4a44' }}>{label}</p>
        {payload.map(p => (
          <p key={p.dataKey} style={{ color: p.color, fontWeight: 600 }}>
            {p.name}: {p.value} mmHg
          </p>
        ))}
      </div>
    );
  }
  return null;
}

export default function GrafikonPritiska({ merenja }) {
  if (!merenja || merenja.length < 2) {
    return (
      <div className="card chart-section">
        <h3>📈 Grafikon pritiska</h3>
        <div className="empty-state" style={{ padding: '32px 0' }}>
          <p>Dodajte najmanje 2 merenja da biste videli grafikon.</p>
        </div>
      </div>
    );
  }

  const podaci = [...merenja]
    .sort((a, b) => new Date(a.datumVreme) - new Date(b.datumVreme))
    .slice(-30)
    .map(m => ({
      datum: format(new Date(m.datumVreme), 'd. MMM', { locale: sr }),
      Sistolni: m.sistolni,
      Dijastolni: m.dijastolni,
      ...(m.puls ? { Puls: m.puls } : {})
    }));

  return (
    <div className="card chart-section">
      <h3>📈 Grafikon pritiska <span style={{ fontSize: '0.8rem', color: '#9c8278', fontFamily: 'Nunito', fontWeight: 400 }}>(poslednjih 30 merenja)</span></h3>
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={podaci} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0e8e4" />
          <XAxis dataKey="datum" tick={{ fontSize: 11, fill: '#9c8278' }} />
          <YAxis domain={[40, 200]} tick={{ fontSize: 11, fill: '#9c8278' }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
          <ReferenceLine y={120} stroke="#c0614a" strokeDasharray="4 4" strokeOpacity={0.4} />
          <ReferenceLine y={80} stroke="#3d7a74" strokeDasharray="4 4" strokeOpacity={0.4} />
          <Line
            type="monotone" dataKey="Sistolni"
            stroke="#c0614a" strokeWidth={2.5}
            dot={{ r: 3, fill: '#c0614a' }} activeDot={{ r: 5 }}
          />
          <Line
            type="monotone" dataKey="Dijastolni"
            stroke="#3d7a74" strokeWidth={2.5}
            dot={{ r: 3, fill: '#3d7a74' }} activeDot={{ r: 5 }}
          />
          {podaci[0]?.Puls && (
            <Line
              type="monotone" dataKey="Puls"
              stroke="#e8a857" strokeWidth={2}
              dot={{ r: 3, fill: '#e8a857' }} activeDot={{ r: 5 }}
            />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
